import { useConnectionStore } from '../stores/connectionStore';
import { signalRService } from './signalr/signalRService';

/** 登入／恢復連線後向 Hub 宣告上線，更新 DB 並通知好友。 */
export async function announceUserPresence(): Promise<void> {
  try {
    await signalRService.start();
    await signalRService.invoke('UserOnline');
    useConnectionStore.getState().markOnline();
  } catch (err) {
    console.error('announceUserPresence failed（user_online_status 不會更新）:', err);
  }
}
